import React from "react";
import { Link } from "react-router-dom";

const CardLarge = ({ img, title, link, text, pop, action }) => {
/* eslint-disable no-unused-expressions */
  const linkAction = (e) => {
    if(action) {
      e.preventDefault;
      action();
    }
  }

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <a title={title} href={link} onClick={linkAction} target='_blank'>
          <img src={img} alt={title} className="card-img"/>
        </a>
        <p>{text}</p>
        <p className="pop">{pop}</p>
      </div>
    </div>
  );
};

export default CardLarge;
